import { translate } from "../translate/translate";
import { SapImportDisplayStatus, SapImportHealth } from "../models/general/sap-integration-health";

export const PRICE_LOAD_ID = "price";

/** Destino do card de Preço por PN: a aba contextual da análise, ou a lista quando não há análise resolvida. */
export const buildPriceDetailsUrl = (analysisId?: number | null): string =>
  analysisId ? `/general/analysis/${analysisId}/materiais-demandas` : "/general/analysis";

export const mapExecutionStatus = (status?: string | null): SapImportDisplayStatus => {
  if (status === "UPDATED" || status === "PARTIALLY_UPDATED") return "healthy";
  if (status === "ERROR") return "critical";
  if (status === "PROCESSING") return "processing";
  return "not_run";
};

export const getOverallImportStatus = (imports: SapImportHealth[]): SapImportDisplayStatus => {
  const statuses = imports.map(item => item.status);
  if (statuses.includes("critical")) return "critical";
  if (statuses.includes("processing")) return "processing";
  if (statuses.includes("not_run")) return "not_run";
  return "healthy";
};

export const getImportResultMessage = (item: SapImportHealth): string => {
  if (item.status === "critical" && item.errorMessage) return item.errorMessage;
  switch (item.status) {
    case "healthy":
      return translate.t("import_result_success");
    case "critical":
      return translate.t("import_result_error");
    case "processing":
      return translate.t("import_result_processing");
    default:
      return translate.t("import_result_not_run");
  }
};

const dateLocale = (): string => (translate.language === "en" ? "en-US" : "pt-BR");

export const formatImportDate = (item: SapImportHealth): string => {
  if (item.status === "not_run") return translate.t("no_execution_recorded");

  const value = item.finishedAt ?? item.startedAt;
  if (!value) return translate.t("no_execution_recorded");

  const formatted = new Intl.DateTimeFormat(dateLocale(), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));

  if (item.status === "processing") return `${translate.t("import_started_at")} ${formatted}`;
  return formatted;
};

export const formatImportDuration = (item: SapImportHealth): string => {
  if (item.status === "not_run") return translate.t("not_available");
  if (item.status === "processing" && item.durationSeconds === null) return translate.t("in_progress_label");
  if (item.durationSeconds === null) return translate.t("not_available");

  const hours = Math.floor(item.durationSeconds / 3600);
  const minutes = Math.floor((item.durationSeconds % 3600) / 60);
  const seconds = item.durationSeconds % 60;

  if (hours > 0) return `${hours} h ${minutes} min`;
  if (minutes > 0) return `${minutes} min`;
  return `${seconds} s`;
};
